export default function (amount, currency, blank = '') {
  amount = amount != null ? amount : 0;
  currency = typeof currency !== 'undefined' ? currency : 'USD';
  if (typeof amount === 'string') {
    amount = parseFloat(amount);
  }

  return !amount && blank ? blank : amount.formatMoney(currency);
}
